module.exports = __webpack_public_path__ + "img/Trator e pulverizador.4ac8132e.webp";